import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';

import { Routes } from 'constants/routes.constants';
import { useNofomoStore } from 'services/stores';

export const useAfterSignInPath = () => {
  const { replace, query } = useRouter();
  const queryRedirectUrl = query['redirect_url']?.toString();
  const { setAfterSignInUrl, resetAfterSignInUrl, replaceAfterSignInUrl } =
    useNofomoStore((state) => state.actions);
  const afterSignInUrl = useNofomoStore((state) => state.afterSignInUrl);

  const redirectToAfterSignIn = useCallback(
    (fallback?: string) => {
      const redirectTo = !!afterSignInUrl
        ? afterSignInUrl
        : (fallback ?? Routes.Account);
      resetAfterSignInUrl();
      replace(redirectTo);
    },
    [afterSignInUrl, replace, resetAfterSignInUrl],
  );

  // Give priority over the query param
  useEffect(() => {
    if (!!queryRedirectUrl) {
      replaceAfterSignInUrl(queryRedirectUrl);
    }
  }, [queryRedirectUrl, replaceAfterSignInUrl]);

  return {
    afterSignInUrl: afterSignInUrl || Routes.Account,
    setAfterSignInUrl,
    resetAfterSignInUrl,
    redirectToAfterSignIn,
  };
};
